import React from 'react';  
import Table from '../../../core/Table'; 
import { viewData,deleteData } from '../../../core/HttpAction'; 
import {withRouter} from 'react-router-dom'; 

const Url='/book-quantity'; 
const updateUrl='/library/book-add-delete/add/';

const columns=[
    {
        key:'code',
        displayName:'Access Code', 
    }, 
    {
        key:'title',
        displayName:'Title'
    },  
]; 
 
class BookDetailView extends React.Component {
    constructor(props) {
        super(props); 
        this.state={ 
            data:[],
            preloader:this.props.match.params.id?true:false, 
        };  
        this.delete = this.delete.bind(this);  
        this.fetchData = this.fetchData.bind(this); 
    }


    componentDidMount(){
 
        if(this.props.match.params.id){
            this.fetchData();
        }
    } 

    fetchData(){
        viewData(Url+'/'+this.props.match.params.id).then((res)=>{
            if(res.data.status===200){ 
                this.setState({data:res.data,preloader:false});
            }
        });
    }
    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData('/book-quantity/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        const {preloader,data} = this.state; 
 
        return (
            <Table
                data={data} 
                preloader={preloader}
                addEditUrl={`${updateUrl}${this.props.match.params.id}`} 
                permission="book-add-delete"
                title="Individual Book Add Or Delete"
                columns={columns}
                primaryKey="book_quantity_detail_id" 
                delete={this.delete.bind(this)}
                backbtn={`/library/book-action/${this.props.match.params.id}`}
            />  
        );
    }
}
 
 
export default  withRouter(BookDetailView);  


// WEBPACK FOOTER //
// ./src/components/Library/Book/AddDeleteBook.js